import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import axios, { resumeOwnSession } from 'config/axios';
import Header from 'components/Header';
import Button from 'components/Button';
import TextInput from 'components/TextInput';
import Popup from 'components/Popup';
import { getAuth } from 'firebase/auth';
import firebaseApp from 'config/firebase';
import { useAuthContext } from 'context/AuthContext';
import useOutsideClickHandler from 'hooks/useOutsideClickHandler';

import './index.css';

function Profile() {
    const auth = getAuth(firebaseApp);
    const { user, setUser } = useAuthContext();

    const [update, setUpdate] = useState(false);
    const [userData, setUserData] = useState(user);
    const [originalData, setOriginalData] = useState(user);
    const [error, setError] = useState('');

    const errorRef = useOutsideClickHandler(() => setError(''));

    const updateUserInfo = () => {
        axios.post(`tutors/tutors/${auth.currentUser.uid}/update/`, {
                ...userData
            })
            .then(async res => {
                // A new email ends the tutor's own session; the server sends a token
                // to sign straight back in so the tutor stays signed in.
                const { customToken, ...tutor } = res.data;
                if (customToken) await resumeOwnSession(customToken).catch(() =>
                    setError('Your email was updated. Please sign in again with your new email.'));
                setOriginalData(tutor);
                setUserData(tutor);
                setUser(tutor);
            })
            .catch(error => {
                setUserData(originalData);
                setError('Failed to update instructor.');
                console.log(error);
            });
    }

    const failedPopup = (
        <Popup
            title='Failed'
            primaryButtonText='Close'
            primaryButtonOnClick={() => setError('')}
            innerRef={errorRef}
        >
            {error}
        </Popup>
    );

    return (
        <div className='profile'>
            <Helmet>
                <title>
                    Profile - Test Center Admin
                </title>
            </Helmet>
            <Header title='My Profile' />
            {error && failedPopup}
            <div className='profile__grid'>
                <TextInput
                    label='First name'
                    value={userData.firstName}
                    disabled={!update}
                    onChange={event => setUserData({
                        ...userData,
                        firstName: event.target.value
                    })}
                />
                <TextInput
                    label='Last name'
                    value={userData.lastName}
                    disabled={!update}
                    onChange={event => setUserData({
                        ...userData,
                        lastName: event.target.value
                    })}
                />
                <TextInput
                    label='Email'
                    value={userData.email}
                    disabled={!update}
                    onChange={event => setUserData({
                        ...userData,
                        email: event.target.value
                    })}
                />
                <TextInput
                    label='Phone number'
                    value={userData.phoneNumber}
                    disabled={!update}
                    onChange={event => {
                        const value = event.target.value.replace(/[^\d]/g, '');
                        if (value.length <= 15) {
                            setUserData({
                                ...userData,
                                phoneNumber: value
                            });
                        }
                    }}
                />
            </div>
            <Button
                className='profile__update'
                secondary={update}
                onClick={() => {
                    if (update) updateUserInfo();
                    setUpdate(!update);
                }}
            >
                {update ? 'Save' : 'Edit'}
            </Button>
        </div>
    );
}

export default Profile;